import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/memberships/setup/$member-number')({
  beforeLoad: (ctx) => {
    const { user } = ctx.context;
    const { 'member-number': memberNumber } = ctx.params;

    const membership = user.memberships
      .find(membership => membership.member_number.toString() === memberNumber);

    if (!membership) {
      // TODO: include membership in redirect and toast notification details
      throw redirect({
        to: '/memberships/setup'
      });
    }

    return { membership };
  },
  component: Outlet,
  head: ({ params }) => {
    return {
      meta: [
        { title: `Membership #${params['member-number']} | Setup | myTalquin` }
      ]
    };
  }
});
